<div class="series-input-container" [formGroup]="form" #seriesInput>
  <!-- Series Name Select -->
  <mat-form-field appearance="fill" class="series-name-select">
    <mat-label>Series Name</mat-label>
    <input  #nameText 
            type="text" 
            placeholder="Series Name" 
            formControlName="seriesName" 
            matInput
            [matAutocomplete]="nameAuto" />
    <mat-autocomplete 
          #nameAuto="matAutocomplete" 
          class="series-name-select"
          >
      <!-- Filtered Series Names -->
      @for (name of filteredSeriesNames | async; track name) {
      <mat-option [value]="name" class="series-name">
        {{ name }}
      </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
  <!-- Series Reading Order Entry -->
  <mat-form-field appearance="fill" class="reading-order">
    <mat-label>Reading Order</mat-label>
    <input matInput placeholder="Reading Order" #readingOrderText type="number" formControlName="readingOrder" />
  </mat-form-field>

  <button mat-mini-fab 
          class="button btn"   
          matTooltip="Add Series" 
          [disabled]="!isValid()"
          [matTooltipDisabled]="!isValid()"
          (click)="addSeriesEvt($event)">
    <mat-icon fontIcon="add_circle"></mat-icon>
  </button>
  <button mat-mini-fab 
          class="button btn " 
          matTooltip="Cancel" 
          (click)="clearSeriesForm()">
    <mat-icon fontIcon="cancel"></mat-icon>
  </button>
</div>